import client from "./client";

export default {

    async getPenaltySettings(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/penalty-settings', filters)));
    },
    async getPenaltySetting(id) {
        return client.parseResponse(await client.get('/penalty-settings/' + id));
    },
    async createPenaltySetting(data) {
        return client.parseResponse(await client.post('/penalty-settings', data))
    },
    async editPenaltySetting(data) {
        return client.parseResponse(await client.put('/penalty-settings/' + data.id, data))
    },
    async deletePenaltySetting(data) {
        return client.parseResponse(await client.delete('/penalty-settings/' + data.id))
    }
}
